<template>
  <li v-if="isVisible">
    <div v-if="!hasChildren">
      <router-link
        v-if="!hasChildren"
        exact-active-class="nav__link__primary--active"
        :class="['nav__link', 'nav__link__primary', 'd-flex', isOpenSingle(route.name) ? 'nav__link__primary--active' : '']"
        :to="{name: route.name}"
      >
        <div class="nav__nav-icon">
          <span v-if="isStackedIcon" class="fa-stack">
            <font-awesome-icon :icon="route.meta.icon[0]" class="fa-stack-1x" />
            <font-awesome-icon :icon="route.meta.icon[1]" class="fa-stack-1x fa-inverse fa-xs" />
          </span>
          <font-awesome-icon v-else :icon="route.meta.icon" />
        </div>
        {{ name }}
        <span v-if="route.meta.isNew && !isOpenSingle(route.name)" class="nav__nav-new font-weight-bold pl-2 pr-1 text-white">
          {{ $t('NEW') }}
        </span>
      </router-link>
    </div>
    <div v-else>
      <div v-b-toggle="'mc-' + name" class="nav__link nav__link__primary d-flex">
        <div class="nav__nav-icon">
          <span v-if="isStackedIcon" class="fa-stack">
            <font-awesome-icon :icon="route.meta.icon[0]" class="fa-stack-1x" />
            <font-awesome-icon :icon="route.meta.icon[1]" class="fa-stack-1x fa-inverse fa-xs" />
          </span>
          <font-awesome-icon v-else :icon="route.meta.icon" />
        </div>
        {{ $t(name) }}
        <div class="nav__nav-tooltip-icon">
          <font-awesome-icon icon="angle-right" />
        </div>
      </div>
      <b-collapse :id="'mc-' + name" accordion="menu" :visible="isOpen(route.name)">
        <li v-if="route.name === 'help'">
          <div></div>
        </li>
        <menu-item-secondary v-for="(childRoute, index) in route.children" :key="index" :route="childRoute" />
      </b-collapse>
    </div>
  </li>
</template>

<script>
import MenuItemSecondary from "./MenuItemSecondary";
import companyAccount from "@/imports/mixins/companyAccount";
import company from "@/imports/mixins/company";
export default {
  name: "MenuItemPrimary",
  components: {MenuItemSecondary},
  mixins: [companyAccount, company],
  props: {
    route: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    isVisible: function() {
      if(this.route.name === 'buy-leads'){
        return this.showBuyLeads;
      }
      if(this.route.name === 'settings'){
        return this.showSettings;
      }
      if(this.route.name === 'offer-finance'){
        return this.showFinance && this.companyCanOfferFinance && !this.isLimitedAccount;
      }
      if(this.route.name === 'dashboard'){
        return this.showDashboard;
      }
      return this.route.meta
        && (this.route.meta.visible === undefined || this.route.meta.visible);
    },
    name: function() {
      return this.$t(this.route.meta.text ?? this.route.name
        .toLowerCase()
        .split("-")
        .map(s => s.charAt(0).toUpperCase() + s.slice(1))
        .join(" "));
    },
    hasChildren: function() {
      return this.route.children && this.route.children.length > 0
    },
    isStackedIcon: function() {
      return Array.isArray(this.route.meta.icon);
    }
  },
  methods: {
    isOpen(name) {
      return (this.$route.matched.length > 1 && this.$route.matched[0].name === name);
    },
    isOpenSingle(name) {
      return this.$route.matched.length === 1 && this.$route.matched[0].name === name && !this.$route.children;
    }
  }
}
</script>

<style scoped lang="scss">
  .fa-stack {
    height: 1em;
    width: 1em;

    &-1x {
      width: 1em;
    }
  }

  .nav {

    &__nav-icon {
      align-items: center;
      display: flex;
    }
  }
</style>
